import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, DatePicker, message } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowCircleLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import axios from "../../../components/utils/Interceptors";
import getDataById from "../../../hooks/getDataById";
import moment from "moment"; // Only for DatePicker default values; remove if not wanted
import { toast } from "react-toastify";

const UpdateCoupon = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const user = JSON.parse(localStorage.getItem("user"));
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCoupon = async () => {
      const res = await getDataById("vendor/getbyidcoupon", state);
      if (res.status_code === 200) {
        const data = res.data[0];
        form.setFieldsValue({
          coupon_id: data.coupon_id,
          coupon_code: data.coupon_code,
          coupon_type: data.coupon_type,
          minimum_purchase_amount: data.minimum_purchase_amount,
          maximum_discount: data.maximum_discount,
          from_date: moment(data.from_date), // Use string if not using moment
          to_date: moment(data.to_date),
        });
      }
    };
    fetchCoupon();
  }, [form, state]);

  const onFinish = async (values) => {
    const fromDate = values.from_date.format("YYYY-MM-DD");
    const toDate = values.to_date.format("YYYY-MM-DD");

    if (toDate < fromDate) {
      return toast.error("Coupon end date can't be less than start date");
    }

    const info = {
      id: values.coupon_id,
      to_date: toDate,
      minimum_purchase_amount: values.minimum_purchase_amount,
      maximum_discount: values.maximum_discount,
    };

    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_APIURL}/vendor/updatecoupon`,
        JSON.stringify(info),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      const response = res.data;

      if (response?.status_code === 200) {
        toast.success(response.message);
        navigate("/vendor/coupons");
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Update failed");
    }
  };

  return (
    <div className="mt-2 mb-16 p-4 bg-white max-w-4xl mx-auto shadow-md rounded">
      <Row justify="space-between" align="middle" className="mb-4">
        <h2 className="text-lg font-semibold">{t("update_coupon")}</h2>
        <Link to="/vendor/coupons">
          <button   className="btn btn-primary w-full rounded-md text-white">
         <FaArrowCircleLeft />   {t("add_new_product_back")}
          </button>
        </Link>
      </Row>

      <Form layout="vertical" form={form} onFinish={onFinish} autoComplete="off">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t("add_coupon_code")} name="coupon_code">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="coupon_id" className="hidden">
              <Input type="hidden" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label={t("add_coupon_type")} name="coupon_type">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={t("update_coupon_Purchase")}
              name="minimum_purchase_amount"
            >
              <Input type="number" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={t("update_coupon_m_d")}
              name="maximum_discount"
            >
              <Input type="number" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label={t("update_coupon_f_date")} name="from_date">
              <DatePicker disabled className="w-full" format="YYYY-MM-DD" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={t("update_coupon_end_date")}
              name="to_date"
              rules={[
                {
                  required: true,
                  message: "Please select end date",
                },
              ]}
            >
              <DatePicker className="w-full" format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          {/* <Button type="primary" htmlType="submit">
            {t("vd_pc_btn2")}
          </Button> */}
          <button
            className="btn btn-primary w-full rounded-md text-white mt-2"
            type="submit"
          >
            {t("vd_pc_btn2")}
          </button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UpdateCoupon;

